import { gql } from "@apollo/client";

export const GET_CHANNEL = gql`
    query ChannelQuery($id:Long!) {
        getChannel(id:$id) {
            id
            channelName
            companyName
            companyAddress
            contactName
            contactPhone
            email
            taxRate
            taxId
            status
            remark
        }
    }
`;

export interface ChannelType {
    id: string,
    channelName: string,
    companyName: string,
    companyAddress: string,
    contactName: string,
    contactPhone: string,
    email: string,
    taxRate: string,
    taxId: string,
    status: number,
    remark: string,
}

export interface channelTypeResponse {
    getChannel: ChannelType;
}